type CacheKeys = 'RECENT_AND_POPULAR' | 'SUGGESTIONS' | 'FILTERS';

export const inMemoryCache = new Map<CacheKeys, any>();
